import { DraggableColLabels } from '../../../../../store/StatsBaseTableStore'

export const isColEntityProduct = (colLabel: DraggableColLabels): boolean => {
  return colLabel === DraggableColLabels.PRODUCTS
}